export const secondsToString = (time: number) => {
  if (time === 0) return `00:00`
  let timeString = ''
  const currentMinutes = Math.floor(time / 60)
  if (currentMinutes < 10) {
    timeString += `0${currentMinutes}:`
  } else {
    timeString += `${currentMinutes}:`
  }
  const seconds = time - 60 * currentMinutes
  if (seconds < 10) {
    timeString += `0${seconds}`
  } else {
    timeString += `${seconds}`
  }
  return timeString
}
